import * as React from "react";
import { SocialMediaLink } from "src/components/socialMediaLink";
import { staffData } from "public/data/staff";
import "src/styles/staff.css"
import { getFlagEmoji } from "src/scripts/utility";
import { StaffProfileIcon, StaffRoleIcon } from "src/components/spriteWrappers";
import { PageTitle } from "src/components/pageTitle";
import { Link } from "react-router-dom";

export function Staff(props){
	return <StaffView 
	data={staffData}
	/>
}

interface StaffCategoryProps {
	name: string;
	color: string;
	staff: StaffMemberProps[];
	language?: string; // change to enum probably
}

function StaffCategory(props: StaffCategoryProps){	
	return (<div className="staff-category">
		<h2 className="category-title" style={{backgroundColor: props.color}}>{props.name}</h2>
		<div className="staff-member-container">
			{props.staff.map(staff => {
				return <React.Fragment key={staff.slug}><StaffMember
				name={staff.name}
				slug={staff.slug}
				bio={(props.language === "jp" && staff.bioJp) || staff.bio}
				color={staff.color}
				socialMedia={staff.socialMedia}
				rolePrimary={(props.language === "jp" && staff.rolePrimaryJp) || staff.rolePrimary}
				rolePrimarySlug={staff.rolePrimarySlug}
				roleSecondary={staff.roleSecondary}
				pronouns={(props.language === "jp" && staff.pronounsJp) || staff.pronouns}
				country={staff.country}
				/>
				</React.Fragment>
			})}
		</div>
	</div>)
}

interface StaffMemberProps {
	name: string;
    slug: string;
    bio: string;
    bioJp?: string;
    color: string;
    link?: string;
    socialMedia?: {[platform: string]: string};
    rolePrimary: string;
    rolePrimaryJp?: string;
    rolePrimarySlug: string;
    roleSecondary?: string[];
    pronouns: string;
    pronounsJp?: string;
    country?: string;
}

function StaffMember(props: StaffMemberProps){
	return (<>
		<div className="staff-member" style={{"--member_color": props.color, 
			//"--role-icon-url": `url('../images/staff_icons/${props.rolePrimarySlug}.png')`
			}}>
			<div className="icon-and-text">
				<div className="picture-and-icon">
					{/* <img className="staff-picture" src={`/images/staff/${props.slug}/icon.png`}/> */}
					<StaffProfileIcon slug={props.slug} />
					<div className="role-icon-backdrop"/>
					<StaffRoleIcon slug={props.rolePrimarySlug} />
				</div>
				<svg viewBox="0 0 100 100" className="circle-text">
					<defs>
					<path id="circle"
						d="
						M 50, 50
						m -37, 0
						a 37,37 0 1,1 74,0
						a 37,37 0 1,1 -74,0"/>
					</defs>
					<text fontSize="10" letterSpacing="0.5" fontWeight="bold">
					<textPath xlinkHref="#circle" startOffset="15%" textAnchor="middle">
						{props.name.toUpperCase()}
					</textPath>
					</text>
				</svg>
			</div>

			<p className="pronouns">{props.pronouns} {props.country && getFlagEmoji(props.country)}</p>
			<p className="roles">
				<b>{props.rolePrimary}{props.roleSecondary?.map((role) => `, ${role.toLowerCase()}`)}</b>
			</p> {/* add secondary roles */}
			<p className="bio" dangerouslySetInnerHTML={{__html: props.bio}}/>
			<div className="socials-container" style={{"--link-color":`var(--member_color)`}}>
				{Object.keys(props.socialMedia ?? {}).map(social => {
					return <React.Fragment key={social}>
					<SocialMediaLink 
					to={props.socialMedia[social]}
					name={props.name}
					platform={social}
					/>
					</React.Fragment>
				})}
			</div>
		</div>
	</>)
}

function StaffView(props){
	return (
	<>
	<PageTitle pageTitle="Staff"/>
	<main className="main-staff standard-width">
        <h1 className="page-heading">Staff</h1>
		<div className="page-description">
            <p>
                On this page you can learn about the folks behind the scenes who bring Dream Flower Idols to life! For a complete list of credits, see <Link to="/credits">credits</Link>.
            </p>
        </div>
		{Object.keys(props.data).map(category => {
			return (
			<React.Fragment key={category}>
				<StaffCategory
				name={(props.language === "jp" && props.data[category].nameJp) || props.data[category].name}
				color={props.data[category].color}
				staff={props.data[category].staff}
				language={props.language}
				/>
			</React.Fragment>)
		})}
    </main>
	</>)
}